import { get, post, put, del } from '../api-config';

const gcemService = '/gcem';

export const getAgendaTypes = () => get(gcemService, `/activity-type`, null, null);

export const getNextAgendasEvents = (data: any) =>
  get(gcemService, `/event/find/by-groups`, null, {
    init: data.init,
    size: data.size,
    referenceFilter: data.referenceFilter === 'mine',
  });

export const getPatientAgenda = (params: any) => get(gcemService, `/activity/find`, null, params);

export const postAddPatientAgenda = (data: any) => post(gcemService, `/activity`, data, null);

export const putPatientAgenda = (data: any) => put(gcemService, `/activity`, data, null);

export const deletePatientAgenda = (data: any) => del(gcemService, `/activity/${data.agendaId}`);


export const getPatientAgendaEvents = (params: any) => get(gcemService, `/event/find`, null, params);

export const getAgendaEvent = async (data: any) => await get(gcemService, `/event/${data.eventId}`, null, null);

export const putNotifyAgendaEvent = (data: any) => put(gcemService, `/event/${data.id}/notify`, null, null);
